"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Select = _interopRequireDefault(require("../Select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var generateTimes = function generateTimes(step) {
  var day = new Date(1970, 0, 1, 0, 0, 0, 0);
  var times = [];

  while (day.getDate() === 1) {
    var time = day.toLocaleTimeString('en-US');
    times.push(time.replace(/:\d+ /, ' '));
    day.setMinutes(day.getMinutes() + step);
  }

  return times;
};

var generateOptions = function generateOptions(step) {
  return generateTimes(step).map(function (time, index) {
    return _react["default"].createElement("option", {
      key: index,
      value: time
    }, time);
  });
};

var getNextHour = function getNextHour() {
  var now = new Date();
  now.setHours(now.getHours() + 1);
  now.setMinutes(0);
  return now.toLocaleTimeString('en-US').replace(/:\d+ /, ' ');
};

function TimeSelect(_ref) {
  var className = _ref.className,
      step = _ref.step,
      value = _ref.value,
      onChange = _ref.onChange;
  var currentValue = value ? value : getNextHour();
  return _react["default"].createElement(_Select["default"], {
    className: className,
    value: currentValue,
    onChange: onChange
  }, generateOptions(step));
}

TimeSelect.displayName = 'TimeSelect';
TimeSelect.propTypes = {
  className: _propTypes["default"].string,
  step: _propTypes["default"].number,
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func
};
TimeSelect.defaultProps = {
  className: '',
  step: 30
};

var _default = (0, _react.memo)(TimeSelect);

exports["default"] = _default;